<template>
    <footer class="main-footer section flex flex-col xl:flex-row items-center xl:items-end justify-center px-base xl:px-gap-lg">
        <div class="brand mb-base xl:mb-0">
            <img src="/img/villa-kanedolo-logo.svg" alt="">
        </div>

        <div class="_copyright flex flex-col items-center xl:items-start text-xs md:text-sm text-white">
            <span>{{ $root.Config.currentYear }}. {{ $t('All rights reserved') }}.</span>
            <router-link :to="{ name: 'terms', params: { locale: $i18n.locale() } }" class="text-white active:text-primary hover:text-primary focus:text-primary trans-color mt-1" exact>{{ $t('Terms and conditions') }}</router-link>
        </div>
        <div class="_author flex flex-col items-center xl:items-end">
            <img src="/img/safe-in-croatia.png" alt="safe in croatia" class="_safe-img">
            <div class="text-xs md:text-sm text-white mt-base xl:mt-0">{{ $t('Designed and developed by') }} <a href="http://pnc.hr" target="_blank" class="text-white hover:text-primary trans-color">{{ $root.Config.authorSignature }}</a></div>
        </div>
    </footer>
</template>

<script>
export default {}
</script>
